import produce from 'immer';
import { DatacenterAction } from '../actions/Datacenters';
import * as Constants from '../constants/action-constants';
import initialState from '../InitialState';
import { Datacenters } from '../types/Datacenters';

const datacenters = (
  state: Datacenters = initialState.datacenters,
  action: DatacenterAction
): Datacenters => {
  const nextState = produce<Datacenters, Datacenters>(state, draft => {
    switch (action.type) {
      case Constants.REQUEST_DATACENTERS:
      case Constants.UPDATE_DATACENTER:
      case Constants.UPDATE_VCENTER:
        draft.fetching = true;
        draft.failed = false;
        break;
      case Constants.REQUEST_DATACENTERS_FAILED:
      case Constants.UPDATE_DATACENTER_FAILED:
      case Constants.UPDATE_VCENTER_FAILED:
        draft.fetching = false;
        draft.failed = true;
        break;
      case Constants.REQUEST_DATACENTERS_SUCCESS: {
        const { fetchChildren, datacenters: dcList } = action.payload;
        draft.fetching = false;
        draft.items = fetchChildren
          ? dcList
          : dcList.map(dc => {
              const existingDc = draft.items.find(
                d => d.dataCenterVmid === dc.dataCenterVmid
              );
              if (existingDc) {
                return {
                  ...dc,
                  vCenters: existingDc.vCenters
                };
              }
              return dc;
            });
        break;
      }

      case Constants.UPDATE_DATACENTER_SUCCESS: {
        const { datacenter, isEdit } = action.payload;
        draft.fetching = false;
        if (!isEdit) {
          draft.items.push(datacenter);
        } else {
          const index = draft.items.findIndex(
            d => d.dataCenterVmid === datacenter.dataCenterVmid
          );
          draft.items.splice(index, 1, {
            ...state.items[index],
            dataCenterName: datacenter.dataCenterName,
            primaryLocation: datacenter.primaryLocation
          });
        }
        break;
      }
      case Constants.UPDATE_VCENTER_SUCCESS: {
        const { dataCenterVmid, vCenter, isEdit } = action.payload;
        const datacenter = draft.items.find(
          dc => dc.dataCenterVmid === dataCenterVmid
        );
        draft.fetching = false;
        if (datacenter) {
          if (!isEdit) {
            if (datacenter.vCenters) {
              datacenter.vCenters.push(vCenter);
            } else {
              datacenter.vCenters = [vCenter];
            }
          } else {
            if (datacenter.vCenters) {
              const index = datacenter.vCenters.findIndex(
                vc => vc.vCenterName === vCenter.vCenterName
              );
              datacenter.vCenters.splice(index, 1, vCenter);
            }
          }
        }
        break;
      }

      case Constants.DELETE_DATACENTER: {
        const { dataCenterVmid } = action.payload;
        const index = draft.items.findIndex(
          d => d.dataCenterVmid === dataCenterVmid
        );
        if (index >= 0) {
          draft.items.splice(index, 1);
        }
        break;
      }

      case Constants.DELETE_VCENTER: {
        const { dataCenterVmid, vCenterName } = action.payload;
        const datacenter = draft.items.find(
          d => d.dataCenterVmid === dataCenterVmid
        );
        if (datacenter && datacenter.vCenters) {
          const index = datacenter.vCenters.findIndex(
            vc => vc.vCenterName === vCenterName
          );
          datacenter.vCenters.splice(index, 1);
        }
        break;
      }
      // no default
    }
  });
  return nextState;
};

export default datacenters;
